// /vs/zynthoro-vs-netsuite — audit D1.4 / D5.3.

import ComparisonPage from "./ComparisonPage";

const DATA = {
  slug: "netsuite",
  competitor: "NetSuite",
  title: "Zynthoro vs NetSuite — Honest comparison | Zynthoro",
  description:
    "Side-by-side comparison of Zynthoro and Oracle NetSuite: pricing model, modules, AI assistants and migration.",
  heroHeadline: "Zynthoro vs NetSuite.",
  heroIntro:
    "NetSuite is a long-established, deep ERP backed by Oracle, typically sold through a sales-led process. Zynthoro is an AI-native all-in-one platform with published, fixed-tier pricing and four built-in AI specialists. Here's how they compare on the points buyers tell us matter most.",
  pricing: {
    zynthoro: {
      price: "From €79 one-time, or from €499/month",
      note: "Published, fixed tiers you can buy without a sales call. Lifetime Kickstart from €79. Full ERP (all 12 modules) via the Enterprise plan from €2,499/month.",
    },
    competitor: {
      price: "Sales-led — no public price",
      note: "NetSuite does not publish pricing. Engagements are typically scoped to modules, users and implementation, and the final figure is quoted on request.",
    },
    disclaimer:
      "Vendor pricing changes over time. Numbers above are directional; confirm the latest on each vendor's own site.",
  },
  matrix: [
    { feature: "Published pricing", zynthoro: true, competitor: false },
    { feature: "Time to a usable workspace", zynthoro: "Same day for the fictional demo", competitor: "Implementation-led" },
    { feature: "Four built-in AI specialists", zynthoro: true, competitor: "Oracle AI add-ons available" },
    { feature: "Voice input in product workflows", zynthoro: true, competitor: "Not a core marketed feature" },
    { feature: "EU data residency option", zynthoro: true, competitor: "Depends on edition and region" },
    { feature: "Lifetime (one-time) entry option", zynthoro: "Kickstart 1-3 (€79-€199)", competitor: "Not offered" },
    { feature: "Full ERP (all 12 modules)", zynthoro: "Enterprise plan only", competitor: true },
    { feature: "Public, no-call pricing page", zynthoro: true, competitor: false },
  ],
  migration:
    "Migration options depend on your current tools and data. We'll review the available route with you during the demo call.",
  faq: [
    {
      q: "Does Zynthoro really replace NetSuite?",
      a: "For teams with standard CRM, projects, finance and operations needs, Zynthoro Enterprise covers the full 12-module ERP footprint. For global multi-entity consolidation, heavy manufacturing MRP or deep public-sector compliance, NetSuite's depth may still be the better fit. We'll be honest with you on the demo call.",
    },
    {
      q: "Why is NetSuite's pricing sales-led?",
      a: "NetSuite scopes each engagement to the customer's modules, user count and implementation complexity, so each quote is bespoke. Zynthoro publishes fixed tiers you can evaluate without a call.",
    },
    {
      q: "Can I run both while I evaluate?",
      a: "Yes — Zynthoro can run alongside your existing NetSuite workspace during an evaluation. Mandatory data-protection rights apply either way; see our DPA for details.",
    },
    {
      q: "What about enterprise controls and audit?",
      a: "Zynthoro is EU-hosted, GDPR-by-default and operated by Casa Haya International B.V. (KvK 99196581). Full enterprise audit controls land with the Enterprise plan. If you need a specific framework attested today, mention it on the demo call.",
    },
  ],
};

export default function ZynthoroVsNetSuite() {
  return <ComparisonPage data={DATA} />;
}
